/**
 * Aparência (Appearance) Module Routes
 * Theme System - Palette Selection
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

const AparenciaPage = lazy(() => import("@/pages/aparencia/AparenciaPage"));

export const aparenciaRoutes: ModuleRoutes = {
  moduleId: "aparencia",
  basePath: "/aparencia",
  routes: [
    {
      path: "/aparencia",
      element: <AparenciaPage />,
    },
  ],
};
